export default async function getBasicData() {
  return [
    {
      key: 'address',
      icon: 'fe fe-home',
      role: 'admin',
      children: [
        {
          key: 'areas',
          url: '/areas',
        },
        {
          key: 'locations',
          url: '/locations',
        },
        {
          key: 'address',
          url: '/addresses',
        },
      ],
    },
    {
      key: 'costTypes',
      icon: 'fe fe-command',
      url: '/costtypes',
    },
    {
      key: 'inventoryClassCostTypes',
      icon: 'fe fe-shopping-cart',
      url: '/inventoryclasscosttypes',
    },
    {
      key: 'inventoryclass',
      icon: 'fe fe-hard-drive',
      url: '/inventoryclasses',
    },
    {
      key: 'inventorys',
      icon: 'fe fe-bookmark',
      url: '/inventories',
    },
    {
      key: 'parts',
      icon: 'fe fe-package',
      url: '/parts',
    },

  ]
}
